import React, { useRef, useState, useEffect } from "react";
import { ReactComponent as ClipSvg } from "./clipboard.svg";
import { ReactComponent as JoystickSvg } from "./joystick.svg";
import { ReactComponent as DiscordSvg } from "./discord.svg";
import { useNavigate } from "react-router-dom";
import { GAME_SERVER_IP, DISCORD_LINK, API_URL } from "./Consts";
import ImageBox from "./ImageBox";
import LoadingSpinner from "./LoadingSpinner";

export default function Main() {
  const [isAnimating, setIsAnimating] = useState(false);
  const [boxesLoaded, setBoxesLoaded] = useState(false);
  const [loadedCount, setLoadedCount] = useState(0);
  const [copied, setCopied] = useState(false);
  const [playerCount, setPlayerCount] = useState(-2);

  function copyIpToClipboard() {
    setIsAnimating(true);
    setTimeout(() => setIsAnimating(false), 300);
    navigator.clipboard
      .writeText(GAME_SERVER_IP)
      .then(() => {
        console.log("Server IP:" + GAME_SERVER_IP + " copied to clipboard");
        setTimeout(() => setCopied(true), 150);
      })
      .catch((err) => {
        console.error("Failed to copy IP address: ", err);
      });
  }

  function launchGame() {
    setIsAnimating(true);
    window.location.href = "steam://run/1250/";
    setTimeout(() => setIsAnimating(false), 300);
    setTimeout(() => setCopied(false), 150);
  }

  const handleRedirect = () => {
    window.location.href = DISCORD_LINK;
  };

  const handleImageLoad = () => {
    setLoadedCount((prevCount) => {
      const newCount = prevCount + 1;

      if (newCount === 2) {
        setBoxesLoaded(true);
      }

      return newCount;
    });
  };

  useEffect(() => {
    fetchPlayerCount();

    const intervalId = setInterval(fetchPlayerCount, 20000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  const fetchPlayerCount = async () => {
    fetch(API_URL + "/player-count", {
      method: "GET",
    })
      .then((response) => response.json())
      .then((data) => {
        if (data == null) {
          setPlayerCount(-1);
        } else {
          setPlayerCount(data.player_count);
        }
      })
      .catch((error) => {
        setPlayerCount(-1);
      });
  };

  return (
    <>
      <div className="root">
        <div className="logoContainer">
          <div className="logo">
            <b>kfOne</b>
          </div>
          <div className="underLogo">
            <b>Killing Floor 1 Server</b>
          </div>
        </div>

        <div className="menu">
          <ImageBox
            boxType={"leftBox"}
            boxTitle={"Info"}
            imagePath={"./fp.png"}
            boxLoaded={boxesLoaded}
            onImageLoad={handleImageLoad}
            onClickPath={"/info"}
          />
          <div className="middleBoxes">
            <div className="middleTopBox">
              <div className="boxBoldedText">
                <b>kfOne | 80lvl</b>
              </div>
              {copied ? (
                <div className="boxIPText" onClick={launchGame}>
                  <b>Press again to launch!</b>
                  <JoystickSvg
                    className={isAnimating ? "clipboardClicked" : "clipboard"}
                  />
                </div>
              ) : (
                <div className="boxIPText" onClick={copyIpToClipboard}>
                  <b>{GAME_SERVER_IP}</b>
                  <ClipSvg
                    className={isAnimating ? "clipboardClicked" : "clipboard"}
                  />
                </div>
              )}

              <div className="boxText">
                <b>
                  {playerCount == "-2" ? (
                    <LoadingSpinner />
                  ) : playerCount == "-1" ? (
                    "Server is currently offline"
                  ) : (
                    playerCount + "/30 players"
                  )}
                </b>
              </div>
            </div>
            <div onClick={handleRedirect} className="middleBottomBox">
              <div className="discordContainer">
                <DiscordSvg className="discord" />
              </div>
            </div>
          </div>
          <ImageBox
            boxType={"rightBox"}
            boxTitle={"Shop"}
            imagePath={"./sc.png"}
            boxLoaded={boxesLoaded}
            onImageLoad={handleImageLoad}
            onClickPath={"/shop"}
          />
          <footer>
            <p>© {new Date().getFullYear()}</p>
          </footer>
        </div>
      </div>
    </>
  );
}
